module.exports = __webpack_public_path__ + "static/media/animal_05_big.9d7854c9.png";